import axios from "axios";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import baseUrl from "../../baseUrl";
import { parseJwt } from "../../utils/parseJwt";
import Spinner from "../Spinner/Spinner";

const FollowerCard = ({ follower }) => {
  const token = JSON.parse(localStorage.getItem("WM:user-token"));
  const [loading, setLoading] = useState(false);
  const handleUnfollow = (id) => {
    setLoading(true);
    axios
      .post(
        `${baseUrl}/user/unfollow-user`,
        { id, userId: parseJwt(token).id },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        toast.success(res.data.message);
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setLoading(false));
  };
  return (
    <>
      {loading && <Spinner />}
      <tr className="border-b border-gray-200 hover:bg-gray-100">
        <td className="py-3 px-6 text-left">
          <div className="flex justify-center items-center">
            <div className="mr-2">
              <img
                className="w-6 h-6 rounded-full"
                src={follower.avatar["url"]}
                alt="follower-avatar"
              />
            </div>
          </div>
        </td>
        <td className="py-3 px-6 text-left">
          <div className="flex items-center">
            <Link
              className="text-indigo-700 "
              to={`/blog-by-user/${follower._id}`}
            >
              <span>{follower.fullName}</span>
            </Link>
          </div>
        </td>
        <td className="py-3 px-6 text-left">
          <div className="flex items-center">
            <span>{follower.email}</span>
          </div>
        </td>
        <td className="py-3 px-6 text-center">
          <span className="bg-purple-200 text-purple-600 py-1 px-3 rounded-full text-xs">
            Follower
          </span>
        </td>
        <td className="py-3 px-6 text-center">
          <span
            onClick={() => {
              handleUnfollow(follower._id);
            }}
            className="bg-red-200 cursor-pointer text-red-600 hover:bg-red-600 hover:text-red-200 py-1 px-3 rounded-lg text-sm"
          >
            Unfollow
          </span>
        </td>
      </tr>
    </>
  );
};

export default FollowerCard;
